<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="参数名称" prop="configName" >
        <a-input v-model="form.configName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数分组" prop="configGroup">
        <a-input v-model="form.configGroup" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数键名" prop="configKey">
        <a-input v-model="form.configKey" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数类型" prop="configType">
        <a-radio-group v-model="form.configType" button-style="solid" @change="changeType">
          <a-radio-button v-for="(d, index) in configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="参数键值" prop="configValue" v-if="form.configType !== '4'">
        <a-input v-model="form.configValue" placeholder="请输入" v-if="form.configType === '1'" />
        <a-textarea v-model="form.configValue" placeholder="请输入" v-if="form.configType === '2'" />
        <editor v-model="form.configValue" v-if="form.configType === '3'" />
      </a-form-model-item>

      <a-form-model-item label="json格式" v-if="form.configType === '4'">
        <div v-if="form.configName == '分销规则'">
          <a-col :sm="12">
            <span>直推抽成百分之三:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.direct_thrust_ratio" placeholder="" />
          </a-col>
          <a-col :sm="12">
            <span>间推抽成百分之1:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.indirect_thrust_ratio" placeholder="请输入" />
          </a-col>
        </div>
        <div v-if="form.configName == '积分规则'">
          <a-col :sm="12">
            <span>每次打卡:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.every_sign" placeholder="" />
          </a-col>
          <a-col :sm="12">
            <span>第一天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.one_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第二天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.two_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第三天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.three_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第四天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.four_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第五天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.five_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第六天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.six_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>第七天:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.seven_sign" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>发图文:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.publish_image" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>发视频:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.publish_video" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>看广告:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.watch_advertise" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>关注:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.follow_user" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>邀请:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.invite_register" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>收藏:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.collect" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>转发:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.trans" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>浏览发现:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.browse.browse_discover" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>浏览挑战赛:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.browse.browse_challenge" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>浏览课程:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.browse.browse_course" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>浏览商家:</span
            ><a-input style="width: 120px" v-model="form.configValue.browse.browse_shop" placeholder="请输入" />
          </a-col>
          <a-col :sm="12">
            <span>浏览门店:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.browse.browse_store" placeholder="请输入" />
          </a-col>
          <!-- <a-input v-model="form.configValue.browse.browse_discover" placeholder="请输入" />
        <a-input v-model="form.configValue.browse.browse_challenge" placeholder="请输入" />
        <a-input v-model="form.configValue.browse.browse_course" placeholder="请输入" />
        <a-input v-model="form.configValue.browse.browse_shop" placeholder="请输入" />
        <a-input v-model="form.configValue.browse.browse_store" placeholder="请输入" /> -->
        </div>
        <div v-if="form.configName == '商品库存告警'">
          <a-col :sm="24">
            <span>胜天半子定价值参数:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
        </div>
        <div v-if="form.configName == '胜天半子定价值参数'">
          <a-col :sm="24">
            <span>胜天半子定价值参数:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '商品订单收益冻结天数'">
          <a-col :sm="24">
            <span>商品订单收益冻结天数:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '自动收货时间'">
          <a-col :sm="24">
            <span>自动收货时间:&emsp;</span><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '提现规则'">
          <a-col :sm="12">
            <span>{{ form.configValue.moneyStr }}:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.money" placeholder="" />
          </a-col>
          <a-col :sm="12">
            <span>{{ form.configValue.rateStr }}:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.rate" placeholder="请输入" />
          </a-col>
        </div>
        <div v-if="form.configName == '金币兑换比例'">
          <a-col :sm="24">
            <span>金币兑换比例:&emsp;</span><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '金币兑换比率'">
          <a-col :sm="24">
            <span>金币兑换比例:&emsp;</span><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '课程学院结算比例'">
          <a-col :sm="24">
            <span>课程学院结算比例:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '会员支付积分抵扣规则'">
          <a-col :sm="12">
            <span>积分抵扣现金比率:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.ratio" placeholder="" />
          </a-col>
          <a-col :sm="12">
            <span>抵扣上限:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue.percent" placeholder="请输入" />
          </a-col>
        </div>
        <div v-if="form.configName == '挑战赛动态发布次数限制'">
          <a-col :sm="24">
            <span>挑战赛动态发布次数限制:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <!-- <span>{{ (form.remark) }}</span> -->
        </div>
        <div v-if="form.configName == '每天浏览送积分次数上限'">
          <a-col :sm="24">
            <span>每天浏览送积分次数上限:&emsp;</span
            ><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <!-- <span>{{ (form.remark) }}</span> -->
        </div>
        <div v-if="form.configName == '平台电话'">
          <a-col :sm="24">
            <span>平台电话:&emsp;</span><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <!-- <span>{{ (form.remark) }}</span> -->
        </div>
        <div v-if="form.configName == '控制启动页开关'">
          <a-col :sm="24">
            <span>控制启动页开关:&emsp;</span><a-input style="width: 120px" v-model="form.configValue" placeholder="" />
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '默认头像'">
          <a-col :sm="24">
            <span>默认头像:&emsp;</span>
            <!-- <a-input style="width: 120px" v-model="form.configValue" placeholder="" /> -->
            <file-upload
              type="image"
              :defaultList="form.imgArr1"
              :count="1"
              @input="getImg($event, 'introducePic')"
            ></file-upload>
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
        <div v-if="form.configName == '创建者背景图片'">
          <a-col :sm="24">
            <span>创建者背景图片:&emsp;</span>
            <!-- <a-input style="width: 120px" v-model="form.configValue" placeholder="" /> -->
            <file-upload
              type="image"
              :defaultList="form.imgArr"
              :count="1"
              @input="getImg($event, 'picture')"
            ></file-upload>
          </a-col>
          <span>{{ form.remark }}</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="系统内置" prop="configSystem">
        <a-radio-group v-model="form.configSystem" button-style="solid">
          <a-radio-button v-for="(d, index) in typeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import Editor from '@/components/Editor'
import { guid } from '@/utils/ruoyi'
export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true,
    },
  },
  components: {
    Editor,
  },
  data() {
    return {
      isConfigTy: 0,
      submitLoading: false,
      formTitle: '',
      configTypeOptions: [
        { value: '1', label: '输入框' },
        { value: '2', label: '文本框' },
        { value: '3', label: '富文本' },
      ],
      // 表单参数
      form: {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configSystem: 'Y',
        configType: '1',
        imgCount: 1,
        imgArr: [],
        remark: undefined,
      },
      open: false,
      rules: {
        configName: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configGroup: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configKey: [{ required: true, message: '参数键名不能为空', trigger: 'blur' }],
        configValue: [{ required: true, message: '参数键值不能为空', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configSystem: 'Y',
        configType: '1',
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加参数'
      this.isConfigTy = 0
      this.configTypeOptions = [  { value: '1', label: '输入框' },
        { value: '2', label: '文本框' },
        { value: '3', label: '富文本' },]
    },

    changeType(e) {
      // if(e.target.value=='4'){
      //   this.form.configValue = JSON.parse(this.form.configValue)
      // }
      // else{
      //   this.form.configValue = JSON.stringify(this.form.configValue)
      // }
      // console.log(this.form.configValue, 'val')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.open = true
      this.formTitle = '修改参数'
      this.reset()
    
      const configId = row ? row.id : ids
      getConfig(configId).then((response) => {
        this.form = response.data
        // if (row.configName == '分销规则') {
        //   this.form.configValues = JSON.parse(JSON.stringify(this.form.configValue))
        //   this.form.configValue = JSON.parse(this.form.configValue)
        // } else if (row.configName == '积分规则') {
        //   this.form.configValues = JSON.parse(JSON.stringify(this.form.configValue))
        //   this.form.configValuer = JSON.parse(this.form.configValue)
        // } else if (row.configName == '提现规则') {
        //   this.form.configValue = JSON.parse(this.form.configValue)
        // } else if (row.configName == '会员支付积分抵扣规则') {
        //   this.form.configValue = JSON.parse(this.form.configValue)
        // } 
        if (row.configName == '默认头像') {
          let that = this
          this.form.imgArr1 = []
          this.form.imgArr1.push({
            uid: guid(8, 10),
            name: that.form.configValue,
            status: 'done',
            halfUrl: that.form.configValue,
            url: that.form.configValue,
            path: that.form.configValue,
          })
        } else if (row.configName == '创建者背景图片') {
          let that = this
          this.form.imgArr = []
          this.form.imgArr.push({
            uid: guid(8, 10),
            name: that.form.configValue,
            status: 'done',
            halfUrl: that.form.configValue,
            url: that.form.configValue,
            path: that.form.configValue,
          })
        }
        if (
        row.configName == '分销规则' ||
        row.configName == '积分规则' ||
        row.configName == '商品库存告警' ||
        row.configName == '胜天半子定价值参数' ||
        row.configName == '商品订单收益冻结天数' ||
        row.configName == '自动收货时间' ||
        row.configName == '提现规则' ||
        row.configName == '金币兑换比例' ||
        row.configName == '金币兑换比率' ||
        row.configName == '课程学院结算比例' ||
        row.configName == '会员支付积分抵扣规则' ||
        row.configName == '挑战赛动态发布次数限制' ||
        row.configName == '每天浏览送积分次数上限' ||
        row.configName == '平台电话' ||
        row.configName == '控制启动页开关' ||
        row.configName == '默认头像' ||
        row.configName == '创建者背景图片'
      ) {
        this.configTypeOptions = [{ value: '4', label: 'json格式' }]
        this.form.configType = '4'
        this.isConfigTy = 1
      } else {
        this.configTypeOptions = [  { value: '1', label: '输入框' },
        { value: '2', label: '文本框' },
        { value: '3', label: '富文本' },]
        this.isConfigTy = 0
      }
      })
     
    },
    /** 提交按钮 */
    submitForm: function () {
    

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
